import { CSSResult, css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const secondaryNavStyle = {
  gap: css`var(--csc-secondary-nav-gap, ${csSpacing.spacing06})`,
  menuItemListGap: css`var(--csc-secondary-nav-menu-item-list-gap, ${csSpacing.spacing05})`,
  menuItemListPaddingInline: css`var(--csc-secondary-nav-menu-item-list-padding-inline, 0)`,
  menuItemListPaddingBlock: css`var(--csc-secondary-nav-menu-item-list-padding-block, 0)`,
}
export const style: CSSResult = css`
  :host {
    display: block;
  }

  .secondary-nav {
    display: flex;
    flex-direction: column;
    gap: ${secondaryNavStyle.gap};
    padding-inline: ${secondaryNavStyle.menuItemListPaddingInline};
    padding-block: ${secondaryNavStyle.menuItemListPaddingBlock};
  }

  .menu-item-list {
    display: flex;
    flex-direction: column;
    gap: ${secondaryNavStyle.menuItemListGap};
  }

  cse-link {
    display: block;
    --cse-link-text-decoration-line: none;
  }
`
